// Core Imports
import React from 'react';
import Container from 'react-bootstrap/Container';

import Banner from '../assets/images/aboutus/about-banner-long.jpeg'

// Privacy Policy Component
const PrivacyPolicy = () => {
    return (
        <div>
            {/* Breadcrumb Section */}
            <section id="breadcrumbs" className="breadcrumbs"
                style={{
                    backgroundImage: `url(${Banner})`,
                }}
            >
                <div className="container">
                    <h1>Privacy Policy</h1>
                    <ul>
                        <li><a href="./">Home</a></li>
                        <li>Privacy Policy</li>
                    </ul>
                </div>
            </section>

            {/* Privacy Policy Content */}
            <section className="entry">
                <Container>

                    {/* Section: Data Collection Overview */}
                    <div className="pri-policy">
                        <h2>We collect information</h2>
                        <p>We use technologies like cookies, web beacons, or unique device identifiers to anonymously identify your device for a better experience. We also log browser, OS, and IP address info.</p>
                        <p>We may collect personally identifiable information such as your name, address, phone number, or email address.</p>
                        <p>If we inadvertently collect information from children under 13, please contact us to remove it or obtain parental consent.</p>
                        <p>Our service does not currently recognize the “Do Not Track” browser signal.</p>
                    </div>

                    {/* Section: Collection Methods */}
                    <div className="pri-policy">
                        <h2>How we collect personally identifiable information</h2>
                        <p>We may collect your name, mailing address, and email address during registration.</p>
                        <p>Cookies may be used for login sessions. You can disable cookies, but this may limit some features.</p>
                    </div>

                    {/* Section: Use of Personal Data */}
                    <div className="pri-policy">
                        <h2>How we use your personally identifiable information</h2>
                        <p>We use your personal data to notify you of SADP updates and improvements. We may combine this data with other info to enhance our services.</p>
                        <p>We may use your info to send important notices or policy updates. To opt out of emails, contact <a href="mailto:office@southernalpsdp.co.nz">office@southernalpsdp.co.nz</a>.</p>
                    </div>

                    {/* Section: Anonymous Location Data */}
                    <div className="pri-policy">
                        <h2>We may collect and share anonymous location data</h2>
                        <p>We may collect real-time location data anonymously to personalize and improve services. Consent may be requested on first use.</p>
                    </div>

                    {/* Section: Access to Personal Data */}
                    <div className="pri-policy">
                        <h2>You can request to see your personal data</h2>
                        <p>We do not permit direct association with any specific individual in most cases.</p>
                    </div>

                    {/* Section: Data Retention */}
                    <div className="pri-policy">
                        <h2>We keep personal data for a limited period</h2>
                        <p>We may store some data temporarily. Google services may collect more — see their privacy policies.</p>
                    </div>

                    {/* Section: No Third-Party Sharing */}
                    <div className="pri-policy">
                        <h2>We don’t share your personal data with other companies</h2>
                        <p>We do not store or share your personal information with unrelated third parties.</p>
                    </div>

                    {/* Section: Ads and Anonymous Tracking */}
                    <div className="pri-policy">
                        <h2>Ad companies collect anonymous data. You can opt out.</h2>
                        <p>Ad companies may collect anonymous interest and location data. This data is not tied to your identity.</p>
                        <p>Ad services include:</p>
                        <ul>
                            <li>Admeld</li>
                            <li>AdMob</li>
                            <li>Channel Intelligence</li>
                            <li>DoubleClick</li>
                            <li>Google Display Network</li>
                            <li>Teracent</li>
                        </ul>
                        <p><a href="http://www.google.com/intl/en/policies/technologies/ads/" target="_blank" rel="noopener noreferrer">Privacy Policy and Choices</a></p>
                    </div>

                    {/* Section: Privacy Questions */}
                    <div className="pri-policy">
                        <h2>You can ask privacy questions</h2>
                        <p>Contact us at <a href="mailto:office@southernalpsdp.co.nz">office@southernalpsdp.co.nz</a> with any privacy-related questions or concerns.</p>
                    </div>

                    {/* Section: Service Providers and Data Access */}
                    <div className="pri-policy">
                        <h2>Service providers access data on our behalf</h2>
                        <p>We may share data with vendors and contractors strictly for service delivery. They are bound by confidentiality agreements.</p>
                        <p>Analytics providers like Google may access anonymized data to help us improve services. This data is never tied to individual users.</p>
                        <p>Third-party services include:</p>
                        <ul>
                            <li>Google Ads (Admeld, AdMob, etc.)</li>
                            <li>Google Analytics</li>
                        </ul>
                        <p><a href="http://www.google.com/intl/en/policies/technologies/ads/" target="_blank" rel="noopener noreferrer">Google Ads Privacy Policy</a></p>
                        <p><a href="http://www.google.com/analytics/learn/privacy.html" target="_blank" rel="noopener noreferrer">Google Analytics Privacy Policy</a></p>
                    </div>

                    {/* Section: Data Security */}
                    <div className="pri-policy">
                        <h2>We take steps to protect personal information</h2>
                        <p>While we take reasonable measures to protect data, we cannot guarantee full protection from hackers or human error.</p>
                        <p>Data may be processed or stored in various countries where we operate.</p>
                    </div>

                    {/* Section: Special Disclosures */}
                    <div className="pri-policy">
                        <h2>Special situations may require disclosure of your data</h2>
                        <p>We may disclose data in special cases, such as legal requirements, protecting rights, or in the event of a merger or acquisition.</p>
                    </div>

                    {/* Section: Policy Updates */}
                    <div className="pri-policy">
                        <h2>You can review more privacy-related information</h2>
                        <p>This policy was last updated on 21 May 2025. Any material updates will be posted prominently and sent via email or notification if applicable.</p>
                        <p>For questions, contact <a href="mailto:office@southernalpsdp.co.nz">office@southernalpsdp.co.nz</a></p>
                        <p>&copy; 2025 – Southern Alps Development Projects Ltd</p>
                    </div>

                </Container>
            </section>
        </div>
    );
};

export default PrivacyPolicy;
